import React from 'react';
import { Helmet } from 'react-helmet';
import PageBanner from '../components/page-banner/page-banner.component';
import DeliveryProposal from '../components/product/delivery-proposal/delivery-proposal';
import IndustriesImpacted from '../components/product/industries-impacted/industries-impacted.component';
import ProductProcedure from '../components/product/product-procedure/product-procedure.component';
import ProductStatement from '../components/product/product-statement/product-statement.component';

const Offerings = () => {
  return (
    <>
      <Helmet title="Offerings" />
      <PageBanner
        pageTitle="Offerings"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Offerings"
      />
      <ProductStatement />
      <ProductProcedure />
      <DeliveryProposal />
      <IndustriesImpacted />
    </>
  );
};

export default Offerings;
